<template>
    <TagsDropdown v-bind="$props" v-on="$listeners" :options="countryOptions">
        <!-- Show country flags -->
        <template v-slot:preValue="{ option }">
            <CountryFlag
                v-if="option.id"
                class="country-flag"
                :countryCode="option.id.toLowerCase()"
            />
        </template>
        <template v-slot:preOptionInner="{ option }">
            <CountryFlag
                v-if="option.id && !option.isHeader"
                class="country-flag option"
                :countryCode="option.id.toLowerCase()"
            />
        </template>
    </TagsDropdown>
</template>

<script>
import CountryFlag from 'components/countryFlag/countryFlag.vue';
import TagsDropdown from './TagsDropdown.vue';

export default {
    name: 'CountryTagsDropdown',
    components: {
        CountryFlag,
        TagsDropdown
    },
    props: {
        ...TagsDropdown.props,
        options: {
            type: Array,
            default: () => []
        },
        lazyRender: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String,
            default: 'Add Country'
        },
        countriesData: Object
    },
    computed: {
        countryOptions() {
            const groups = Object.keys(this.countriesData);
            return groups.reduce((result, groupName) => {
                const countries = this.countriesData[groupName];
                const codes = Object.keys(countries);
                const options = codes.map((code) => ({ id: code, displayText: countries[code] }));
                return [
                    ...result,
                    { id: groupName, displayText: groupName, isHeader: true },
                    ...options
                ];
            }, []);
        }
    }
};
</script>

<style lang="scss" scoped>
.country-flag {
    margin-right: 3px;
    &.option {
        margin-left: 5px;
    }
}
</style>
